import React, { useContext } from 'react';
import { ProductImage, ProductName, ProductPrice } from 'anf-core-react';
import tmntHelpers from '../../../tools/tmntHelpers';
import ProductPageContext from '../../../contexts/ProductPageContext';

export default function MatchingSetCard({
  image,
  name,
  brand,
  listPrice = {},
  memberPrice = {},
  onClick,
  tmntData = {},
  onNextSlide,
  onPrevSlide,
}) {
  const ProductPageState = useContext(ProductPageContext);
  const hasMemberPricingEnabled = ProductPageState?.collectionData?.hasMemberPricingEnabled;
  const handleKeyDown = (e) => {
    e.stopPropagation();

    if (e.key === 'ArrowRight') {
      onNextSlide();
    }

    if (e.key === 'ArrowLeft') {
      onPrevSlide();
    }
  };

  if (!image || !name || !brand || !listPrice || !tmntData) return null;

  const hasMemberPrice = hasMemberPricingEnabled && memberPrice?.description;

  return (
    <button
      className="matching-set-card"
      tabIndex="-1"
      aria-label={tmntHelpers.replacePlaceholders(tmntData?.matchingSetCardAriaLabel?.value, { productName: name })}
      onClick={onClick}
      onKeyDown={handleKeyDown}
    >
      <div className="matching-set-card__image">
        <ProductImage
          src={image}
          alt="Main product images"
        />
      </div>
      <div className="matching-set-card__name">
        <ProductName brand={brand}>{name}</ProductName>
      </div>
      <div className="matching-set-card__price">
        <ProductPrice
          brand={brand}
          description={listPrice?.description}
          discountPrice={listPrice?.discountPrice}
          discountText={listPrice?.discountText}
          originalPrice={listPrice?.originalPrice}
          variant={listPrice?.variant}
        />
        {hasMemberPrice && (
          <ProductPrice
            brand={brand}
            discountPrice=""
            discountText={memberPrice?.discountText}
            originalPrice={memberPrice?.originalPrice}
            description={memberPrice?.description}
            variant={memberPrice?.variant}
          />
        )}
      </div>
    </button>
  );
}
